module.exports = __webpack_public_path__ + "static/media/calm-serene.c68d2c1a.png";